import { render, staticRenderFns } from "./PhotographyDownloads.vue?vue&type=template&id=1c3d7a67&scoped=true&"
import script from "./PhotographyDownloads.vue?vue&type=script&lang=js&"
export * from "./PhotographyDownloads.vue?vue&type=script&lang=js&"
import style0 from "./PhotographyDownloads.vue?vue&type=style&index=0&id=1c3d7a67&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3d7a67",
  null
  
)

export default component.exports